import axiosInstance from "./AxiosInstance";

export const subscribe = async (name, email) => {
  try {
    const response = await axiosInstance.post('api/subscribe', {
      name,
      email,
    });

    return response.data || {};
  } catch (error) {
    console.error("Error subscribing:", error);
    throw error;
  }
};
